import { thunk, Action, Thunk, action, Computed, computed } from 'easy-peasy'
import { fetchPricesBraavos } from '../../blockchainUtils/pricesFetcher'

export type Price = Record<string, { usd: number }>

export interface PricingModel {
    prices: Record<string, { usd: number }>

    setPrices: Action<PricingModel, Record<string, { usd: number }>>

    loadPrices: Thunk<PricingModel>

    // eslint-disable-next-line no-unused-vars
    getPrice: Computed<PricingModel, (tokenName: string) => { usd: number }>
}

const priceModel: PricingModel = {
    prices: {},

    setPrices: action((state, payload) => {
        state.prices = { ...state.prices, ...payload }
    }),

    loadPrices: thunk(async (actions) => {
        try {
            const response: Record<string, { usd: number }> = await fetchPricesBraavos()
            // const response: Record<string, { usd: number }> = await fetchPrices()
            actions.setPrices(response)
        } catch (e) {}
    }),

    getPrice: computed((state) => (tokenName) => state.prices[tokenName])
}

export default priceModel
